// extracted by mini-css-extract-plugin
export default {"wrap":"Newtab_wrap__LRTlB","btn":"Newtab_btn__BRj+T"};